import { useLayoutEffect, useRef, type RefObject } from 'react'

export const useFixedPanelBelowNavbar = (): RefObject<HTMLDivElement | null> => {
    const panelRef = useRef<HTMLDivElement>(null)

    useLayoutEffect(() => {
        const panel = panelRef.current
        const navbar = document.getElementById('navbar')
        const header = navbar?.parentElement
        if (!panel || !header) return

        const syncTop = () => {
            panel.style.top = `${Math.round(
                header.getBoundingClientRect().bottom
            )}px`
        }

        syncTop()
        window.addEventListener('resize', syncTop)
        window.addEventListener('scroll', syncTop, true)
        return () => {
            window.removeEventListener('resize', syncTop)
            window.removeEventListener('scroll', syncTop, true)
        }
    }, [])

    return panelRef
}
